import React, { createContext, useContext } from 'react';
import { useTonConnect } from './hooks/useTonConnect';

const TonContext = createContext();

export const useTon = () => {
    const context = useContext(TonContext);
    if (!context) {
        throw new Error('useTon must be used within TelegramTonProvider');
    }
    return context;
};

export const TelegramTonProvider = ({ children }) => {
    const tonConnect = useTonConnect();

    const formatAddress = (address) => {
        if (!address) return '';
        return `${address.slice(0, 6)}...${address.slice(-4)}`;
    };

    const toNano = (amount) => {
        return BigInt(amount * 1000000000); // Convert to nanotons
    };

    const fromNano = (nanoAmount) => {
        return Number(nanoAmount) / 1000000000; // Convert from nanotons
    };

    const value = {
        ...tonConnect,
        formatAddress,
        toNano,
        fromNano,
        address: tonConnect.wallet?.account?.address,
        balance: tonConnect.wallet?.account?.balance || '0'
    };

    return (
        <TonContext.Provider value={value}>
            {children}
        </TonContext.Provider>
    );
};
